export default __webpack_public_path__ + "static/media/Illustration_Antigen-specific_T_cell_enrichment_workflow_001_2500.97f91533.png";